import { ChatBackgroundType, DEFAULT_CHAT_BACKGROUND_PATTERN } from 'APP/constants/appearance';

import { TChatBackground } from './Appearance.types';

export const DEFAULT_CHAT_BACKGROUND: TChatBackground = {
  type: ChatBackgroundType.Pattern,
  background: DEFAULT_CHAT_BACKGROUND_PATTERN,
};
